exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1whct{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}._1whct ._3Xxmb{font-weight:400;margin:75px 0 24px 0;color:var(--brand--color--light);color:var(--brand--color--light);font-size:28px;font-size:1.75rem;letter-spacing:1.2px}._1whct ._2LkzL{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center}._1whct ._2R13i{margin:var(--block--spacing) auto;margin:var(--block--spacing) auto;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;width:80%;font-size:16px}._1whct ._2R13i .nyPoH{height:150px;width:150px;margin-right:30px;border-radius:50%}._1whct ._2R13i ._2xuDH{min-width:275px;-ms-flex:1 1;flex:1 1}._1whct ._2R13i h3{margin-bottom:0}._1whct ._2R13i p{margin:0}._1whct ._2R13i ._32dGj{font-weight:600;font-family:\"Nunito-Sans\",\"Nunito-Light\",\"HelveticaNeue-Light\",sans-serif;margin:0 0 10px;color:#929fb0}@media(max-width: 600px){._2R13i._2R13i{width:100%}}", ""]);

// exports
exports.locals = {
	"team": "_1whct",
	"globalSectionHeading": "_3Xxmb",
	"teamMembers": "_2LkzL",
	"member": "_2R13i",
	"memberPhoto": "nyPoH",
	"memberText": "_2xuDH",
	"role": "_32dGj"
};